import script from "./CadastroProfissional.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroProfissional.vue?vue&type=script&setup=true&lang=js"

import "./CadastroProfissional.vue?vue&type=style&index=0&id=dcd0e0aa&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcd0e0aa"]])

export default __exports__